import React from 'react'
import { useSelector } from 'react-redux'
import FakeDelivery from "app/deliveryTool/components/delivery/FakeDelivery"

const NotFound404 = () => {

  const isLoading = useSelector((state) => state.common.user.isLoading)
  const isInitialized = useSelector((state) => state.common.user.isInitialized)
  const accessToken = window.localStorage.getItem('token')
  // Liste des routes existantes
  const existingRoutes = [
    '/',
    '/informations-devis-manquantes',
    '/planning',
    '/itineraires/',
    '/impression-planning',
    '/impression-planning-public',
    '/agenda',
    '/pipeline-b2b',
    '/pipeline-sav',
    '/recouvrement-impayes',
    '/fiche-production-multipole',
    '/fiche-production-multipole-v2',
    '/anticipation',
    '/commande',
    '/dej_multi_format',
    '/appel_offre',
    '/tableau-des-tournees',
    '/itineraires-b2c',
    '/lmvp-plateaux',
    '/companion'
  ]

  const currentPath = window.location.pathname
  
  // Vérifier si l'URL actuelle correspond à une route existante
  const isExistingRoute = existingRoutes.some(route => {
    if (route === currentPath) return true
    // Vérifier les routes avec paramètres spécifiques
    if (currentPath.startsWith('/itineraires/') && route === '/itineraires/') return true
    if (currentPath.startsWith('/companion/') && route === '/companion') return true
    if (currentPath.startsWith('/appel_offre_prix/') && route === '/appel_offre') return true
    if (currentPath.startsWith('/feuille-de-route/') && route === '/appel_offre') return true
    return false
  })

  const handleGoBack = () => {
    window.history.back()
  }

  const handleGoHome = () => {
    window.location.href = '/'
  }

  // Si on a un token et qu'une route protégée est en cours de chargement, afficher le loader
  if (accessToken && (isLoading || !isInitialized)) {
    return (
      <div className="p-4">
        <FakeDelivery />
      </div>
    )
  }
  
  // Si l'URL correspond à une route existante, ne pas afficher la 404
  if (isExistingRoute) {
    return null;
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px',
      textAlign: 'center',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{
        maxWidth: '600px',
        padding: '40px',
        backgroundColor: 'white',
        borderRadius: '10px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <h1 style={{
          fontSize: '72px',
          color: '#dc3545',
          margin: '0 0 20px 0',
          fontWeight: 'bold'
        }}>
          404
        </h1>
        
        <h2 style={{
          fontSize: '24px',
          color: '#333',
          margin: '0 0 15px 0',
          fontWeight: '600'
        }}>
          Page non trouvée
        </h2>
        
        <p style={{
          fontSize: '16px',
          color: '#666',
          margin: '0 0 30px 0',
          lineHeight: '1.5'
        }}>
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        
        <div style={{
          display: 'flex',
          gap: '15px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={handleGoBack}
            style={{
              padding: '12px 24px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#5a6268'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#6c757d'}
          >
            ← Retour
          </button>
          
          <button
            onClick={handleGoHome}
            style={{
              padding: '12px 24px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
          >
            🏠 Accueil
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFound404
